import React from "react";
import ReactDOM from "react-dom"
import Home from "./Home.jsx";
import '@tencent/universe-ui/build/lib/style.js';
import 'tdesign-react/es/style/index.css'; // 少量公共样式
import "./style/var.scss";
import "./index.css";


import {
  BrowserRouter as Router,
  Route
} from 'react-router-dom';
export default function App() {
  return (
    <Router>
      {/* <Route path="/" component={Home} /> */}
      <Route path="*" component={Home} />
    </Router>
  )
}

const root = document.getElementById("root")
ReactDOM.render(<App />, root)

